import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { SettingsService } from '@app/shared/services/settings/settings.service';

@Injectable({
  providedIn: 'root',
})
export class HasAirbnbEncodedUrlGuard  {
  constructor(
    private readonly router: Router,
    private settingsService: SettingsService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    let encodedUrl: string = route.paramMap.get('encodedUrl');

    if (encodedUrl && encodedUrl !== 'null' && encodedUrl !== 'undefined' && encodedUrl !== 'connect') {
      return of(true);
    } else {
      this.settingsService.getAccounts().subscribe((res) => {
        if (res && res.meta && res.meta.airbnb_auth_url) {
          encodedUrl = `${btoa(res.meta.airbnb_auth_url)}`;

          this.router.navigateByUrl('/accounts/new/airbnb-official/' + encodedUrl);
          return of(false);
        }
      });
    }
  }
}
